import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { navigationDrawerStyles } from "@insite/content-library/Components/NavigationDrawer";
import getColor from "@insite/mobius/utilities/getColor";

import { css } from "styled-components";

navigationDrawerStyles.drawer = mergeToNew(navigationDrawerStyles.drawer, {
    css: css`
        svg {
            stroke: ${getColor("secondary")};
        }
        [class^="TypographyStyle"] {
            text-transform: uppercase;
            font-weight: 600;
        }
    `,
});

navigationDrawerStyles.menuTriggerButton = mergeToNew(navigationDrawerStyles.menuTriggerButton, {
    shape: "box",
    css: css`
        border: 0;
        background-color: ${getColor("primary")};
        &:hover {
            background-color: ${getColor("primary")};
        }
    `,
});
navigationDrawerStyles.drawerSectionWrapper = mergeToNew(navigationDrawerStyles.drawerSectionWrapper, {
    css: css`
        &:first-child {
            margin-top: 0;
            padding-bottom: 0px;
            background: #f8f9fa;
            & button,
            & [class^="StyledButton-sc-"] {
                background: transparent;
                span {
                    color: ${getColor("secondary")};
                }
            }
        }
        &:last-child {
            margin-bottom: 0px;
        }
        margin-top: 0px;
    `,
});
